import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress PostHog/third-party analytics errors that don't affect the app
window.addEventListener('error', (event) => {
  if (event.message?.includes('postMessage') && 
      event.message?.includes('PerformanceServerTiming')) {
    event.preventDefault();
    event.stopPropagation();
    return false;
  }
});

window.addEventListener('unhandledrejection', (event) => {
  if (event.reason?.message?.includes('postMessage') && 
      event.reason?.message?.includes('PerformanceServerTiming')) {
    event.preventDefault();
    event.stopPropagation();
    return false;
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
